var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClock = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_283_658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_283_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69998 11.0334L7.33331 8.66671V5.33337H8.66665V8.11671L10.6333 10.0834L9.69998 11.0334ZM7.33331 4.00004V2.66671H8.66665V4.00004H7.33331ZM12 8.66671V7.33337H13.3333V8.66671H12ZM7.33331 13.3334V12H8.66665V13.3334H7.33331ZM2.66665 8.66671V7.33337H3.99998V8.66671H2.66665ZM7.99998 14.6667C7.07776 14.6667 6.21109 14.4917 5.39998 14.1417C4.58887 13.7917 3.88331 13.3167 3.28331 12.7167C2.68331 12.1167 2.20831 11.4112 1.85831 10.6C1.50831 9.78893 1.33331 8.92226 1.33331 8.00004C1.33331 7.07782 1.50831 6.21115 1.85831 5.40004C2.20831 4.58893 2.68331 3.88337 3.28331 3.28337C3.88331 2.68337 4.58887 2.20837 5.39998 1.85837C6.21109 1.50837 7.07776 1.33337 7.99998 1.33337C8.9222 1.33337 9.78887 1.50837 10.6 1.85837C11.4111 2.20837 12.1166 2.68337 12.7166 3.28337C13.3166 3.88337 13.7916 4.58893 14.1416 5.40004C14.4916 6.21115 14.6666 7.07782 14.6666 8.00004C14.6666 8.92226 14.4916 9.78893 14.1416 10.6C13.7916 11.4112 13.3166 12.1167 12.7166 12.7167C12.1166 13.3167 11.4111 13.7917 10.6 14.1417C9.78887 14.4917 8.9222 14.6667 7.99998 14.6667ZM7.99998 13.3334C9.48887 13.3334 10.75 12.8167 11.7833 11.7834C12.8166 10.75 13.3333 9.48893 13.3333 8.00004C13.3333 6.51115 12.8166 5.25004 11.7833 4.21671C10.75 3.18337 9.48887 2.66671 7.99998 2.66671C6.51109 2.66671 5.24998 3.18337 4.21665 4.21671C3.18331 5.25004 2.66665 6.51115 2.66665 8.00004C2.66665 9.48893 3.18331 10.75 4.21665 11.7834C5.24998 12.8167 6.51109 13.3334 7.99998 13.3334Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock.dbc6afa3.svg";
export { ForwardRef as ReactComponent };